export const SHIPS_PATH = "ships";
export const LAST_SHIP_KEY = "lastShip";
export const SHIPS_MEMBER_KEY = "ships";
